import eventMessage from "./event-message";
import EVENT_MSG_TYPE from "src/constant/event-msg-type";
import { HB_EVENT_NAME } from "src/constant";

let timeoutId = null;
/**
 * 自定义实现原子服务单页应用的LCP监控
 */
export class ServicePageLCP {
  lcpObserver: MutationObserver | null = null;
  // 开始监测采集LCP的相对时间值, 通过performance.now获取的值
  startTime: number;
  // 当前监测到的LCP数据
  metric: {
    value: number; // LCP时间值，单位ms
    timestamp: number; // 触发LCP时间戳
    node: string; // 触发LCP的节点描述
  };
  // 最小监控时长，避免过短时间内的误报，单位ms
  minMonitorDuration: number;
  constructor() {
    this.startTime = 0;
    this.minMonitorDuration = 10000; // 最小监控时长10秒
    this.metric = {
      value: 0,
      timestamp: 0,
      node: '',
    };
  }
  reportLCPEvent(node: string, lcp: number, dateTime: number) {
    eventMessage.publish<HBEventData<HBPerf>>({
      time: dateTime,
      type: EVENT_MSG_TYPE.OTHER,
      data: {
        en: HB_EVENT_NAME.PERF,
        pkey: 'LCP',
        pval: Math.round(lcp),
        attrs: {
          type: 'ymc',
          lcpNode: node,
        }
      },
    });
  }
  startMonitoring(startTime?: number) {
    this.stopMonitoring(); // 确保之前的观察器被断开
    const rootElement = document.getElementById('service-route-root') || document.getElementById('root') || document.getElementById('app') || document.body;
    const now = performance.now();
    const sTime = this.startTime = startTime < now ? startTime : now;
    let maxAddedNodes = 0;
    this.lcpObserver = new MutationObserver((mutations) => {
      const timeElapsed = performance.now() - sTime;
      const addedNodesCount = mutations.reduce((count, mutation) => count + mutation.addedNodes.length, 0);
      if (maxAddedNodes < addedNodesCount) {
        maxAddedNodes = addedNodesCount;
        this.metric = {
          value: timeElapsed,
          timestamp: Date.now(),
          node: '',
        }
      }
      mutations.filter(mutation => mutation.addedNodes.length > 0).forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof HTMLElement) {
            const area = node.clientHeight * node.clientWidth;
            const viewportArea = window.innerHeight * window.innerWidth;
            const classNames = String(node.className).toLowerCase();
            if (/spin|loading|skeleton/.test(classNames)) {
              return; // 忽略加载骨架屏等元素
            }
            if (area >= viewportArea * 0.4) {
              this.metric = {
                value: timeElapsed,
                timestamp: Date.now(),
                node: `${node.tagName.toLowerCase()}${node.id ? `#${node.id}` : ''}${node.className ? `.${String(node.className).split(/\s+/).join('.')}` : ''}`,
              };
              hbLogger.debug('Potential LCP Element:', node, 'Time Elapsed:', timeElapsed, 'Area:', area, 'Class Names:', classNames);
            }
          }
        });
      });
    });
    this.lcpObserver.observe(rootElement, {
      childList: true,
      subtree: true,
    });
    hbLogger.debug('Starting Service LCP Monitoring', startTime);
    timeoutId = setTimeout(() => {
      this.stopMonitoring();
    }, 15000); // 15秒后停止监控
  }
  // 停止监控逻辑
  stopMonitoring() {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
    if (this.lcpObserver) {
      hbLogger.debug('Stopping Service LCP Monitoring', performance.now());
      this.lcpObserver.disconnect();
      this.lcpObserver = null;
    }
    if (this.metric.value > 0 && performance.now() - this.startTime > this.minMonitorDuration) {
      this.reportLCPEvent(this.metric.node, this.metric.value, this.metric.timestamp);
      hbLogger.debug('Reported Service LCP Metric:', this.metric);
    }
    this.metric = {
      value: 0,
      timestamp: 0,
      node: '',
    };
  }
}

export const lcpInstance = new ServicePageLCP();
